import React from 'react';
//components
import { Visibility } from 'components/Visibility';
import { Column } from 'components/Layout/Grid';
import Table from 'components/Table';
import Text from 'components/Text';
//generics
import { modelBudgetSummary } from 'pages/Quotes/MoneyRecordedQuotes/models';
import { IBudgetDropdown } from './interface';

/**
 * @main BudgetDropdown is the main exported component
 * @param integrationMessages it is the integration message list
 */
export const BudgetDropdown: React.FC<IBudgetDropdown> = ({
  integrationMessages,
}) => {
  const index = integrationMessages?.findIndex(x => x.date);
  const visible = integrationMessages?.length > 0;

  return (
    <Column className="animated fadeIn bg-white px-5 py-3">
      <Text className={`font-bold color-blue-gray mt-2 mb-3 ${!visible || index === -1 ? 'text-center' : ''}`} size={12}>
        {`${visible && index !== -1 ? 'Detalhamento do envio' : 'Sem detalhes de envio para essa cotação'}`}
      </Text>
      <Visibility visible={visible && index !== -1}>
        <Table
          trackingKey="Detalhes dos Orçamentos"
          onReload={() => { }}
          setTableOrder={() => { }}
          tableOrder=""
          data={integrationMessages || undefined}
          pageSize={integrationMessages?.length || 1}
          currentPage={0}
          totalPages={1}
          model={modelBudgetSummary}
          portalCustomHeader
        />
      </Visibility>
    </Column>
  );
};
